import $ from 'jquery';
import { useNavigate } from "react-router";
import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { remove } from '../../../services/upload-files.service';
import { start } from '../../../store/slices/TeamManagementSlice';
import { deleteTspReport } from '../../../store/slices/ReportsSlice';

const TspSupplierReportData = ({ data }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false); 

    useEffect(() => {
        if (data && data.length > 0) {
            console.log("Data successfully loaded:", data);
        } else {
            console.log("No data available");
        }
    }, [data]);

    // Sort data by createdAt in descending order (newest first)
    const sortedData = data ? [...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];

    const handleClick = (id) => {
        const routes = `/tspsupplierreportdetails`;
        navigate(routes, { state: id });
    };
    
    const handleDelete = (id, event) => {
        event.stopPropagation();
        setIsLoading(true);
        dispatch(start());
    
        remove(`delete-tsp-excel-file-by-id?id=${id}`)
            .then((success) => {
                if (success) {
                    dispatch(deleteTspReport(id)); // Update Redux state
                    console.log("File deleted successfully");
                }
            })
            .catch((error) => {
                console.error("Error deleting file:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    return (
        <>
            {sortedData && sortedData.length > 0 ? (
                sortedData.map((curData) => {
                    const { id, seller, year, createdAt } = curData;
                    const formattedDateType = formatDate(createdAt); 
                    return (
                        <tr
                            className="clickablerow"
                            key={id}
                            onClick={() => handleClick(id)}
                        >
                            <td>{seller.name}</td>
                            <td>{year}</td>
                            <td>{formattedDateType}</td>
                            <td>
                                <Button
                                    variant="primary"
                                    className="btn btn-primary btn-add"
                                    onClick={(event) => handleDelete(id, event)}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Deleting..." : "Delete Report"}
                                </Button>
                            </td>
                        </tr>
                    );
                })
            ) : (
                <span>No Tsp supplier reports data available.</span>
            )}
        </>
    );
};

export default TspSupplierReportData;